export const getUtmParamsFromStorage = () => {
  try {
    const utmRaw = localStorage.getItem('utm_params');
    return utmRaw ? JSON.parse(utmRaw) : {};
  } catch (e) {
    return {};
  }
};

export const addUtmToUrl = (url, utmParams = null) => {
  if (!utmParams) {
    utmParams = getUtmParamsFromStorage();
  }

  if (Object.keys(utmParams).length === 0) return url;

  const parsedUrl = new URL(url, window.location.origin);
  Object.entries(utmParams).forEach(([key, value]) => {
    parsedUrl.searchParams.set(key, value);
  });

  return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
};

export const addUtmToQuery = (query = {}) => {
  const utm = getUtmParamsFromStorage();
  if (Object.keys(utm).length === 0) return query;
  return { ...query, ...utm };
};
